import { render, staticRenderFns } from "./Produse_dialog.vue?vue&type=template&id=5e9b34a4&"
import script from "./Produse_dialog.vue?vue&type=script&lang=js&"
export * from "./Produse_dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports